import { Module } from '../Module';


interface ITabScope extends ng.IScope {
  isActiveTab: () => boolean;
  tabTitle: string;
  summary?: string;
  summaryDefaultText?: string;
  resetFn?: () => void;
  iconClassFn?: () => string;
}


class TabSetController {
  public static $inject = ['$timeout'];
  constructor(private $timeout: ng.ITimeoutService) {}

  private tabs: ITabScope[] = [];
  private activeTab: ITabScope;

  public addTab(tab: ITabScope) {
    this.tabs.push(tab);
    if (!this.activeTab) {
      this.select(tab);
    }
  }

  public getTabs():ITabScope[] {
    return this.tabs;
  }

  public select(selectedTab: ITabScope) {
    this.activeTab = selectedTab;

    // gfrench@: Workaround for filtering list boxes appearing empty until the next scope digest.
    // I think this is because ScrollCtrl watches its viewport dimensions, but those don't update until the DOM reflows, which happens after the current digest cycle completes.
    // This workaround lets the DOM reflow and then triggers another digest cycle, which allows ScrollCtrl to update itself.
    this.$timeout(() => {}, 0, true);
  }

  public isActiveTab(tab: ITabScope) {
    return this.activeTab === tab;
  }
}

Module.instance().directive('tbTabSet', () => {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      tabsOptions: '=tabList',
    },
    templateUrl: 'tbTabSet.html',
    controller: TabSetController,
    controllerAs: 'tabSetCtrl'
  };
});

Module.instance().directive('tbTab', () => {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: '<div ng-show="isActiveTab()" ng-transclude />',
    scope: {
      iconClassFn: '=',
      resetFn: '=',
      summary: '=',
      summaryDefaultText: '@',
      tabTitle: '='
    },
    require: '^tbTabSet',
    link: (scope: ITabScope, elm: JQuery, attrs: ng.IAttributes, tabsetCtrl: TabSetController) => {
      tabsetCtrl.addTab(scope);
      scope.isActiveTab = () => tabsetCtrl.isActiveTab(scope);
    }
  };
});
